import * as parserNames from "@/utils/parsersNames";

const createParserState = () => ({
  logs: [],
  links: {},
  page: {},
  isRequesting: false,
});

const state = Object.values(parserNames).reduce((state, parserName) => {
  state[parserName] = createParserState();

  return state;
}, {});

export default state;
